module.exports = __webpack_public_path__ + "static/img/produto_p.02a636f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/rc/produto_p.png
// module id = twO4
// module chunks = 0